module.exports = __webpack_public_path__ + "img/char_005.7cefa980.png";